module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.welcomeBG() + ')'
    }),
    attrs: {
      "id": "welcome"
    }
  }, [(!_vm.currentPicker) ? _c('div', {
    staticClass: "startPanel"
  }, [_c('div', {
    staticClass: "topHeading"
  }, [_vm._v(_vm._s(_vm.$t("startTop")))]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.$t("startTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("startText")) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "startButton button white adapted",
    on: {
      "click": _vm.start
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("startButton")) + "\n\t\t")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f82932b8!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/PictureWall/Welcome.vue
// module id = 175
// module chunks = 0